/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useLayout } from '../../../providers/Layout.provider';
import { useAccessTokenFields } from '../../../providers/AccessToken.provider';
import { SafeChargeCC } from './SafeCharge';
import { useToken } from '../../../providers/Token.provider';

const { IframeLayout, SeparatorMoon, SeparatorImg, Image } = vp;

declare const window: Window &
  typeof globalThis & {
    SafeCharge: any;
  };

const loadScript = (src: string) =>
  new Promise((resolve, reject) => {
    const scriptElem = Object.assign(document.createElement('script'), {
      type: 'text/javascript',
      defer: true,
      src,
      onerror: (e: string) => {
        reject(e);
      },
    });
    scriptElem.onload = (e) => {
      resolve(e);
    };
    document.body.appendChild(scriptElem);
  });

type CreditCardFormProps = {
  type: string;
};

type FC = FunctionComponent<CreditCardFormProps>;

const CreditCardContainer: FC = (props: CreditCardFormProps) => {
  const { type } = props;
  const { layout, color, src, height, positionX, positionY, hasBackButton, setLayoutInfo } = useLayout();
  const { extraInfo } = useAccessTokenFields();
  const { token } = useToken();
  const [safeCharge, setSafeCharge] = useState(null);
  const env = import.meta.env.VITE_NUVEI_ENVIRONMENT;
  const merchantId = extraInfo?.MerchantID;
  const merchantSiteId = extraInfo?.MerchantSiteID;

  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  useEffect(() => {
    loadScript('https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js').then(() => {
      setSafeCharge(
        window.SafeCharge({
          env,
          merchantId,
          merchantSiteId,
        }),
      );
    });
  }, []);

  return (
    <IframeLayout
      separator={
        layout === 'img' ? (
          <SeparatorImg width={100} height={110} fill={color} />
        ) : layout === 'moon' ? (
          <SeparatorMoon width={140} height={110} fill={color} />
        ) : (
          <></>
        )
      }
      image={
        src === '' ? (
          <></>
        ) : (
          <Image width="auto" height={height} positionX={positionX} positionY={positionY} src={src} />
        )
      }
      hasBackButton={hasBackButton}
      content={
        <SafeChargeCC
          type={type}
          color={color}
          safeCharge={safeCharge}
          merchantId={merchantId}
          merchantSiteId={merchantSiteId}
        />
      }
    />
  );
};

export default CreditCardContainer;
